import { Link } from 'react-router-dom'
import type { SocialLink } from './types'

export interface TeamCardProps {
  image: string
  name: string
  designation: string
  to: string
  socials: SocialLink[]
}

/**
 * A `.ul-team-member` card. Verified byte-identical between `team.html` (8 cards)
 * and the team section of `about.html` (4 cards), so one component serves both.
 */
export function TeamCard({ image, name, designation, to, socials }: TeamCardProps) {
  return (
    <div className="ul-team-member">
      <div className="ul-team-member-img">
        <img src={image} alt="Team Member Image" />
        <div className="ul-team-member-socials">
          {socials.map((s) => (
            <a key={s.icon} href={s.href} aria-label={s.label ?? s.icon}>
              <i className={`flaticon-${s.icon}`} />
            </a>
          ))}
        </div>
      </div>
      <div className="ul-team-member-info">
        <h3 className="ul-team-member-name">
          <Link to={to}>{name}</Link>
        </h3>
        <p className="ul-team-member-designation">{designation}</p>
      </div>
    </div>
  )
}
